'use strict';
var BuyPathResults = function(resultPage, dynpackBuyPath, flightsBuyPath) {
    this.resultPage = resultPage;
    this.dynpackBuyPath = dynpackBuyPath;
    this.flightsBuyPath = flightsBuyPath;
};
BuyPathResults.prototype.build = function() {
    return 'dpresults' === this.resultPage ? this.dynpackBuyPath : this.flightsBuyPath;
};
module.exports = BuyPathResults;

